import React from "react";

import storageFail from "../../../../assets/images/homepage/ySafe/storageFail.png";
import Button from "components/Button/index";
import Modal from "components/Models/index";

import "./storageFail.scss";

function StorageFail({ handleCancel, isVisible }) {
  // const [show, setShow] = useState(false);

  // const handleCancel = () => {
  //   setShow(!show);
  // };

  return (
    <>
      (
      <Modal handleCancel={handleCancel} showFooter={false} isDisabled>
        <div className="storageFail">
          <div className="storageFailImage">
            <img
              src={storageFail}
              className="storageFailImage"
              alt="storageFail"
            />
          </div>
          <div className="storageFailWrapper">
            <h1>Your Storage is full !!</h1>
            <p>
              It looks like your storage is at capacity. To continue uploading
              files, consider deleting some older ones or upgrading your storage
              plan.
            </p>
          </div>
          <div className="buttonContainer">
            <div className="buttonSubContainer">
              <Button type="white" title="Manage Storage" />
              <Button type="violet" title="Upgrade now" />
            </div>
          </div>
        </div>
      </Modal>
      )
    </>
  );
}

export default StorageFail;
